import { PackageType } from './PackageType'
import { ProductGroupCode } from './ProductEnums'

export const PackageTypeLabels = {
  [PackageType.BASIC]: 'package.package_type.basic',
  [PackageType.PLUS]: 'package.package_type.plus',
  [PackageType.EXTRA]: 'package.package_type.extra'
}

export const PackageNameLabels = {
  CBA: 'package.package_type.basic',
  VBA: 'package.package_type.basic',
  MBA: 'package.package_type.basic',
  CPL: 'package.package_type.plus',
  MPL: 'package.package_type.plus',
  VPL: 'package.package_type.plus',
  CEX: 'package.package_type.extra',
  MEX: 'package.package_type.extra',
  VEX: 'package.package_type.extra'
}

export const VehicleGroupLabels = {
  [ProductGroupCode.CAR]: 'vehicle_registration.car',
  [ProductGroupCode.TRUCK]: 'vehicle_registration.truck',
  [ProductGroupCode.MACHINERY]: 'vehicle_registration.machinery'
}
